export const lensspecificationconstants = {
    RightEyeText: "rightEye",
    LeftEyeText: "leftEye",
    Strength: "Strength",
    Curve: "Curve",
    Diameter: "Diameter",
    Cylinder: "Cylinder",
    Axis: "Axis",
    Add: "Add",
    Color: "Color",
    Packet: "Packet",
    OneTimeShopIdentifier: "1",
    SubscriptionIdentifier: "2",    
    InternalServerError: "InternalServerError",
}